import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignSnackEditUUIDSnackContainer } from "@/components/features/snack/snack/edit/ui/components";

import { useGetParams } from "./hooks/use-get-params";

export const DesignSnackEditPage = () => {
	const { hotelID, uuid } = useGetParams();

	return (
		<PageMeta
			title="スナックの編集"
			url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.EDIT.UUID, { hotelID, uuid })}
		>
			<DesignSnackEditUUIDSnackContainer hotelID={hotelID} uuid={uuid} />
		</PageMeta>
	);
};

DesignSnackEditPage.displayName = "DesignSnackEditPage";
